<template>
  <div v-if="descTemplate" class="ins-result-wrap">
    <liability
      ref="liability"
      :temp="descTemplate"
      :data="descData"
      :show-type="0"
      :miniprogram="miniprogram"
      :product-name-list="productNameList"
      @disShow="fetchDisData"
    />
  </div>
</template>

<script>
import Liability from 'components/liability/liability'

export default {
  name: 'InsResult',
  components: {
    Liability,
  },
  props: {
    template: {
      type: Object,
      default: null,
    },
    productNameList: {
      type: Object,
      default: null,
    },
    miniprogram: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      descTemplate: '',
      descData: '',
      disData: [],
      disActive: 0,
      disVisible: false,
      disHeader: '病种详情',
      disLink: '',
    }
  },
  watch: {
    template(newTemplate) {
      this.pageInit(newTemplate)
    },
  },
  created() {
    this.pageInit()
  },
  methods: {
    // 初始化
    pageInit(temp = this.template) {
      if (temp) {
        this.descTemplate = {
          liabilities: temp.liabilities,
          name: temp.card.name,
          insuranceTypeId: temp.resultData.insuranceTypeId,
          trades: temp.trades,
          accountMap: temp.accountMap,
          insuredAge: temp.insuredAge,
          categorySort: temp.resultData.categorySort,
          categorySortList: temp.categorySortList,
          descShow: temp.descShow,
        }
        this.descData = this.template.calData
      }
    },
    fetchDisData(path) {
      let { pidx, idx } = path

      let liabilities =
        this.descTemplate.liabilities[pidx].insuranceLiabilities[idx]
          .liabilities

      let diseaseAry = []
      liabilities.forEach((liab) => {
        const { title, link, detail } = liab.disease
        title &&
          diseaseAry.push({
            title,
            link,
            detail,
          })
      })
      this.disData = this._normalizeDisText(diseaseAry)
      // this.disHeader = header
      // this.disLink = link
      this.disVisible = true
    },
    _closeDisDialog() {
      this.disVisible = false
    },
    _normalizeDisText(list) {
      let ret = []
      list.forEach((dis, index) => {
        // let text = dis.text
        let { title, link, detail } = dis

        detail = `${detail.replace(
          /\d+[\、|\.]/g,
          '</p><p><span>$&</span>'
        )}</p>`
        detail = detail.replace(/<\/p>/, '')
        ret.push({
          title,
          link,
          detail,
        })
      })
      return ret
    },
  },
}
</script>
